// ============================================================
// Elite Vending - Mock content (frontend-only)
// All copy is original. Contact info kept per request.
// ============================================================

export const company = {
  name: "Elite Vending",
  tagline: "Quality. Service. Excellence.",
  phone: "+61 430 472 144",
  phoneHref: "tel:+61430472144",
  email: "hello@elitevending.com",
  logo: "/elite-vending-logo.png",
  serviceArea: "Country-wide across Australia, UK, USA & Canada"
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Blog", to: "/blog" },
  { label: "Contact Us", to: "/contact" },
  { label: "About Us", to: "/about" }
];

export const footerLinks = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" }
];

export const ticker = [
  "Free Vending Machines",
  "Country-Wide",
  "Call Now",
  "30+ Staff / Foot Traffic",
  "Fully Stocked",
  "Contact Us",
  "Fully Serviced",
  "Tap & Go Payments",
  "Zero Upfront"
];

export const images = {
  heroMachine: "/hero-vending-machine.png",
  machineTall: "https://images.unsplash.com/photo-1575224526797-5730d09d781d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHx2ZW5kaW5nJTIwbWFjaGluZXxlbnwwfHx8fDE3ODcyOTM4NDV8MA&ixlib=rb-4.1.0&q=85",
  machineWall: "https://images.unsplash.com/photo-1618506557292-ec1862b3c506?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHx2ZW5kaW5nJTIwbWFjaGluZXxlbnwwfHx8fDE3ODcyOTM4NDV8MA&ixlib=rb-4.1.0&q=85",
  breakRoom: "https://images.unsplash.com/photo-1692133189378-1ec72461bd35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBicmVhayUyMHJvb218ZW58MHx8fHwxNzg3MjkzODQ1fDA&ixlib=rb-4.1.0&q=85",
  breakRoom2: "https://images.unsplash.com/photo-1606836576983-8b458e75221d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBicmVhayUyMHJvb218ZW58MHx8fHwxNzg3MjkzODQ1fDA&ixlib=rb-4.1.0&q=85",
  snacks: "https://images.unsplash.com/photo-1585341840941-98553e474d84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxzbmFja3MlMjBkcmlua3N8ZW58MHx8fHwxNzg3MjkzODQ1fDA&ixlib=rb-4.1.0&q=85"
};

export const hero = {
  badge: "Elite Vending",
  titleParts: [
    { text: "Premium Vending Machines", gold: true },
    { text: " Installed Free for Qualifying Workplaces", gold: false }
  ],
  subtitle:
    "Fully stocked. Fully serviced. Nothing to pay for eligible sites. We place a brand-new machine at your workplace within days \u2014 perfect for teams of 30+ or spaces with steady foot traffic.",
  bullets: [
    "Brand-new machines",
    "Tap & Go + cash/coin",
    "No lock-in contracts",
    "4-week trial available"
  ]
};

export const stats = [
  { value: "250", suffix: "+", label: "Sites running" },
  { value: "60", suffix: "k+", label: "Products restocked monthly" },
  { value: "24", suffix: "h", label: "Avg response time" },
  { value: "4.9", suffix: "\u2605", label: "Customer rating" }
];

export const lookingToBuy = {
  title: "Thinking about buying a vending machine?",
  intro:
    "Here's the good news: most businesses never need to. We supply modern machines completely free to offices, gyms, warehouses and facilities with 30+ staff or reliable foot traffic.",
  pay: {
    title: "What you pay",
    items: [
      { bold: "Nothing to rent.", rest: "No weekly charges, ever." },
      { bold: "No service bills.", rest: "Upkeep is fully on us." },
      { bold: "No contracts.", rest: "Not a fit? We simply collect it." }
    ]
  },
  get: {
    title: "What you get",
    items: [
      { bold: "The machine, sorted.", rest: "You relax, we handle everything." },
      { bold: "Rapid install.", rest: "Usually up and running days after your visit." },
      { bold: "Stock your way.", rest: "Snacks, drinks, meals and healthy picks." }
    ]
  },
  banner: {
    title: "Free installation for workplaces with 30+ staff",
    note: "Fewer than 30? Still worth asking \u2014 foot traffic and site type can qualify you too."
  }
};

export const whatYouGet = {
  title: "Everything included",
  subtitle: "A polished vending setup that people actually use \u2014 and that never runs empty.",
  features: [
    { icon: "Sparkles", title: "Brand-new modern machine", desc: "Sleek, professional units that suit any modern workplace." },
    { icon: "CreditCard", title: "Tap & Go + cash/coin", desc: "PayWave, cards, phones and watches \u2014 plus notes and coins." },
    { icon: "LayoutGrid", title: "Full product range", desc: "Drinks, snacks, meals and healthier options \u2014 your mix." },
    { icon: "Wrench", title: "Stocked & serviced by us", desc: "Regular restocks and maintenance \u2014 always clean and reliable." },
    { icon: "Radio", title: "Back-to-base monitoring", desc: "We watch stock levels so refills happen before you run dry." },
    { icon: "ShieldCheck", title: "Safety tested", desc: "Electrically tested and compliant, ready the moment it lands." }
  ],
  trial: {
    title: "Risk-free trial",
    items: ["4-week no-obligation trial option", "No lock-in contract", "Barely used? We take it back \u2014 no fuss"]
  },
  specs: {
    title: "Machine specifications",
    items: [
      { label: "Height", value: "1830 mm" },
      { label: "Width", value: "1050 mm" },
      { label: "Depth", value: "830 mm" },
      { label: "Power usage", value: "~ $100 / year" },
      { label: "Power point", value: "Standard outlet required" }
    ]
  }
};

export const whyChoose = {
  title: "Why teams choose Elite Vending",
  intro:
    "Too many vending machines are outdated, half-empty, grubby, cash-only and forgotten. We built Elite Vending to change that \u2014 for good.",
  typical: {
    label: "Typical Vending",
    items: ["Ageing hardware", "Patchy stock levels", "Neglected & unclean", "Cash only", "Rarely serviced"]
  },
  elite: {
    label: "Elite Vending",
    items: ["Sharp, modern machines", "Every payment method welcome", "Auto restock alerts", "Cleaned & maintained", "People genuinely use them"]
  }
};

export const perfectFor = {
  title: "Perfect for",
  intro: "We install across the country in busy spaces like:",
  tags: [
    "Warehouses", "Factories", "Gyms & fitness centres", "Hospitals & clinics",
    "Schools & universities", "Call centres", "Workshops", "Distribution centres",
    "Offices", "Hotels", "Transport depots", "Large retail stores"
  ],
  footnote: "With 30+ staff or steady foot traffic, you qualify \u2014 book a visit and we'll confirm in minutes."
};

export const howItWorks = {
  title: "How it works",
  subtitle: "A simple, hands-off process. We manage it end to end.",
  steps: [
    { n: 1, title: "Free site visit", desc: "We assess your space and access, confirm headcount and suggest the ideal setup." },
    { n: 2, title: "Choose your products", desc: "Pick soft drinks, water, energy drinks, snacks, healthy options, kombucha and more." },
    { n: 3, title: "We install it", desc: "We deliver, test and set it up. It's ready to use the moment we leave." },
    { n: 4, title: "We keep it full", desc: "Levels are monitored automatically \u2014 when they drop, we're there fast to refill." }
  ]
};

export const placementOptions = [
  "Break room / kitchen",
  "Reception / lobby",
  "Warehouse / production floor",
  "Office hallway",
  "Gym / fitness area",
  "Hospital / clinic waiting area",
  "School / university common area",
  "Other (mention in notes)"
];

export const blogPosts = [
  {
    slug: "healthy-vending-workplace",
    title: "Healthy vending: how the right snack mix lifts a workplace",
    excerpt: "Balanced options aren't just a nice-to-have \u2014 they change how a break room feels and how often it's used.",
    date: "12 June 2025",
    category: "Workplace",
    author: "Elite Vending Team",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1585341840941-98553e474d84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxzbmFja3MlMjBkcmlua3N8ZW58MHx8fHwxNzg3MjkzODQ1fDA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "p", text: "The snacks and drinks in a break room say more about a workplace than most people realise. A machine stocked only with sugary fizz and salty chips sends one message; a thoughtful mix that balances treats with genuine energy sends another. Getting that mix right is one of the simplest ways to make a shared space feel looked after." },
      { type: "h", text: "Balance beats restriction" },
      { type: "p", text: "Nobody wants a vending machine that feels like a diet plan. The goal isn't to strip out the chocolate and chips people love \u2014 it's to sit them alongside real alternatives. Protein bars, nuts, baked crisps, flavoured water, cold-pressed juices and low-sugar energy drinks give people a genuine choice rather than a lecture. When the healthy option is right there and just as appealing, people reach for it far more often." },
      { type: "h", text: "Match the mix to the site" },
      { type: "p", text: "A gym floor and a late-shift warehouse want very different things. Fitness sites lean toward protein, hydration and recovery drinks. Warehouses and factories often want hearty snacks and caffeine to get through long shifts. Offices tend to sit in the middle, with steady demand for both comfort snacks and lighter picks. We use the first few weeks of stock data to fine-tune the range for each site." },
      { type: "h", text: "Small change, big lift" },
      { type: "p", text: "When the range fits the people using it, the machine gets busier, the break room feels more inviting, and staff notice that someone actually thought about them. That's the quiet win of a well-planned snack mix \u2014 it turns a box in the corner into a genuine perk." },
      { type: "quote", text: "The best vending range doesn't force a choice \u2014 it simply makes the good option easy." }
    ]
  },
  {
    slug: "tap-and-go-cashless",
    title: "Why cashless Tap & Go is now the standard for vending",
    excerpt: "Coins are fading fast. Here's why modern payments make machines busier and easier to run.",
    date: "28 May 2025",
    category: "Technology",
    author: "Elite Vending Team",
    readTime: "3 min read",
    image: "https://images.unsplash.com/photo-1618506557292-ec1862b3c506?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHx2ZW5kaW5nJTIwbWFjaGluZXxlbnwwfHx8fDE3ODcyOTM4NDV8MA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "p", text: "Not long ago, an empty pocket meant a missed sale. If you didn't have exact change, the machine simply wasn't for you. Tap & Go has quietly rewritten that rule \u2014 and it has changed how busy a machine can be." },
      { type: "h", text: "Fewer barriers, more sales" },
      { type: "p", text: "Cards, phones and smartwatches mean a purchase takes a single tap. There's no hunting for coins, no rejected notes, no walking away disappointed. For the person in front of the machine it feels effortless, and effortless is what drives repeat use throughout the day." },
      { type: "h", text: "Cleaner operation behind the scenes" },
      { type: "p", text: "Cashless payments also make a machine easier to run. There's less cash to collect and reconcile, fewer jams from worn notes, and a clear digital record of what sold and when. That data feeds straight into restocking so popular lines never run dry." },
      { type: "h", text: "Cash still has its place" },
      { type: "p", text: "Going cashless doesn't mean leaving anyone out. Our machines still accept notes and coins, so every visitor is covered. The difference is that Tap & Go is now the default \u2014 the fast, familiar way most people pay." },
      { type: "quote", text: "A single tap removes the biggest reason a sale never happens: friction at the moment of payment." }
    ]
  },
  {
    slug: "free-vending-really-free",
    title: "Free vending machines: what 'free' actually means",
    excerpt: "No rental, no service fees, no contracts. We break down exactly how a zero-cost install works.",
    date: "9 May 2025",
    category: "Guides",
    author: "Elite Vending Team",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1625650484478-113df4bfc370?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHx2ZW5kaW5nJTIwbWFjaGluZXxlbnwwfHx8fDE3ODcyOTM4NDV8MA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "p", text: "\u2018Free\u2019 is a word that makes people cautious \u2014 and rightly so. When we say we install vending machines at no cost for qualifying sites, the natural question is: where's the catch? Here's the honest breakdown." },
      { type: "h", text: "What you don't pay" },
      { type: "p", text: "There's no purchase price, no rental, no weekly fee and no servicing charge. We own the machine, we deliver and install it, and we keep it stocked and maintained. If it isn't working out for your site, we take it away \u2014 no exit fee, no lock-in contract." },
      { type: "h", text: "How it actually works" },
      { type: "p", text: "The model is simple: the machine earns its keep through the products people buy from it. Because we handle stock, service and monitoring at scale, a well-placed machine pays for itself. That's why the deciding factor is foot traffic, not a fee \u2014 sites with 30+ staff or steady visitor numbers make the numbers work." },
      { type: "h", text: "What you provide" },
      { type: "p", text: "All we ask for is a suitable spot, safe access for our team and a standard power point. That's it. We take care of the rest, from the first site visit to every refill afterwards." },
      { type: "quote", text: "Free means free at your end \u2014 the machine simply has to earn its place through the products people love." }
    ]
  },
  {
    slug: "restocking-monitoring",
    title: "Back-to-base monitoring: never see an empty machine again",
    excerpt: "Smart stock tracking means refills happen before anyone notices a gap on the shelf.",
    date: "22 April 2025",
    category: "Service",
    author: "Elite Vending Team",
    readTime: "3 min read",
    image: "https://images.unsplash.com/photo-1575224526797-5730d09d781d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHx2ZW5kaW5nJTIwbWFjaGluZXxlbnwwfHx8fDE3ODcyOTM4NDV8MA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "p", text: "The fastest way to kill a good vending machine is to let it run empty. A single sold-out row tells people the machine can't be relied on \u2014 and once they stop checking, they stop buying. Back-to-base monitoring exists to make sure that moment never arrives." },
      { type: "h", text: "The machine tells us before you notice" },
      { type: "p", text: "Each machine reports its stock levels back to us in real time. Instead of guessing or waiting for a complaint, we can see exactly which lines are running low and plan a refill before the shelf shows a gap. The problem is solved before anyone on site even knows there was one." },
      { type: "h", text: "Smarter refills, not just faster ones" },
      { type: "p", text: "Live data does more than trigger a top-up. It shows us what's genuinely popular at your site and what's gathering dust. Over time we adjust the range so the machine carries more of what your team actually reaches for \u2014 less waste, fresher stock, happier users." },
      { type: "h", text: "Reliability people can feel" },
      { type: "p", text: "When a machine is always stocked, it becomes part of the daily routine. People trust it, use it and rely on it. That quiet consistency is the whole point of monitoring \u2014 it turns a vending machine into something people never have to think twice about." },
      { type: "quote", text: "An empty row costs far more than one lost sale \u2014 it costs the trust that keeps people coming back." }
    ]
  }
];

export const services = [
  { icon: "Building2", title: "Workplace vending", desc: "Turn-key machines for offices and corporate sites, tuned to your team's tastes." },
  { icon: "Dumbbell", title: "Gym & fitness vending", desc: "Protein, hydration, low-sugar snacks and recovery drinks your members will reach for." },
  { icon: "Factory", title: "Warehouse & industrial", desc: "Rugged, high-capacity machines built for shift workers and busy floors." },
  { icon: "GraduationCap", title: "Education campuses", desc: "Compliant, balanced ranges for schools, colleges and universities." },
  { icon: "Stethoscope", title: "Health & clinics", desc: "Quiet, reliable machines for waiting areas and staff rooms." },
  { icon: "Hotel", title: "Hospitality & retail", desc: "24/7 convenience for hotels, depots and large retail spaces." }
];
